export default __webpack_public_path__ + "static/media/210430-Cloudxier Clients Logo-03.50131a42.png";